function isFilteredComponent(componentId) {
    try {
        const rules = Array.isArray(window.WCCP_FILTERING_RULES) ? window.WCCP_FILTERING_RULES : [];
        return rules.some(r => r && r.enabled && String(r.component_id) === String(componentId));
    } catch { return false; }
}

async function tryNarrowComponent(componentEl) {
    const componentId = componentEl.getAttribute('data-item_id');
    if (!componentId) return;
    if (!isFilteredComponent(componentId)) {
        // console.debug('[WCCP] Skip narrowing for', componentId);
        return;
    }
    const selections = collectSelectionsFromStateOrDOM(); // the existing selections collector
    const data = await wccpFetchFilteredComponent(componentId, selections);

    if (!data || !data.products || !data.products.length) {
        if (window.WCCP_DEV_MODE?.debug?.variationSkip) {
            devLog('FILTER_VARIATION_SKIPPED', {
                component_id: componentId,
                reason: 'Component has no backend variation filtering rules'
            });
        }
        NARROW_RESULT.set(key, false);
        return false;
    }
    renderComponentOptions(componentEl, data.products);
}